<template>
  <div class="main">
    <div style="display: flex; margin-top: 50px;">
      <ul style="flex: 0 0 10%;"></ul>
      <div class="list-style">
        <ul
          v-for="item in dataResult"
          :key="item.id"
          :style="{ background: item.isNewMessage ? '#DCDEE2' : ' #F3F3F3' }"
          style="padding-left: 5px"
        >
          <li
            v-if="item.isNewMessage"
            style="
              flex: 0 0 40px;
              background: #ac2e44;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 4px;
              color: white;
            "
          >
            NEW
          </li>
          <li v-else-if="!item.isNewMessage" style="flex: 0 0 40px"></li>
          <li style="color: #11254a">
            {{ item.messageTime }} {{ item.content }}
          </li>
          <li style="flex: 0 0 10%"></li>
        </ul>
      </div>
      <ul style="flex: 0 0 10%; padding: 0px 20px;">
        <div
          @click="refresh" class="refreshDiv" >
          <span>{{ $t('common.refresh') }}</span>
        </div>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.main {
  width: 100%;
  height: calc(100% - 120px);
  overflow: auto;
}
.main::-webkit-scrollbar {
  /*滚动条整体样式*/
  /*高宽分别对应横竖滚动条的尺寸*/
  width: 10px;
  height: 1px;
}
.main::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #c6cad1;
}

.main::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 8px;
  background: #edeef0;
}

.list-style {
  flex: 1;
  width: 80%;
}
.list-style ul {
  display: flex;
  background: #f5f5f5;
  height: 42px;
  align-items: center;
  margin-bottom: 15px;
  border-radius: 4px;
}
.list-style li {
  flex: 1;
  text-align: center;
}

/* 整理内联样式 */
.refreshDiv {
  width: 60px;
  height: 60px;
  background-image: url('/Images/refresh_bg.png');
  background-size: cover;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  cursor: pointer;
}

.refreshDiv span {
  font-size: 15px;
  color: white;
}
@media (max-width: 1024px) {
  .list-style ul {
    display: flex;
    background: #f5f5f5;
    align-items: center;
    height: 120px;
    margin-bottom: 15px;
    border-radius: 4px;
  }
  .refreshDiv {
    background: url('/Images/refresh_bg.png') no-repeat;
    background-size: cover;
    display: block;
  }
  .refreshDiv span {
    line-height: 60px;
  }
}

@media (max-width: 747px) {
  .list-style ul {
    display: flex;
    background: #f5f5f5;
    align-items: center;
    height: 160px;
    margin-bottom: 15px;
    border-radius: 4px;
  }
}
</style>
<script>
export default {
  name: 'Notification',
  data() {
    return {
      dataResult: []
    };
  },
  methods: {
    getNotification() {
      let self = this;
      this.$axios
        .get('/Notification')
        .then(function (res) {
          // console.log(res);
          self.dataResult = res;
          self.$message.success(
            self.$t('notificationPage.gotNewNotification')
          );
        })
        .catch((err) => {
          console.error(err);
        });
    },
    refresh() {
      this.getNotification();
    }
  },
  created() {
    this.$store.getters.get_Server_pictureBase64;
    let user = this.$store.getters.get_user_Info_cache;
    if (user) {
      if (user.isMerchant) {
        this.$router.push({ path: '/shop' });
      } else {
        this.getNotification();
      }
    }
  }
};
</script>
